import {
	LIGHT_GRAY,
	MOBILE_WIDTH,
	MID_WIDTH,
	DPR,
	MAX_YEAR,
	MIN_YEAR,
} from './Constants';
import { getWidth, getHeight, bivariateColor, setHTML } from './Utils';
import LayoutManager from './Layouts';
import * as PIXI from 'pixi.js'; // use pixi@4.8.8
import * as d3 from 'd3';

export function handleTrend(e) {
	if (typeof this.selectedCountry == 'undefined') return;
	//South Sudan
	if (this.selectedCountry == '728') {
		this.layoutManager.layout(
			'scatter',
			Infinity,
			this.selectedCountry,
			0,
			0,
			2011,
			MAX_YEAR
		);
	} else {
		this.layoutManager.layout(
			'scatter',
			Infinity,
			this.selectedCountry,
			0,
			0,
			MIN_YEAR,
			MAX_YEAR
		);
	}
	if (typeof e != 'undefined') {
		e.target.classList.add('active');
		e.target.previousSibling.classList.remove('active');
	}
}
export function handleYear(e) {
	if (typeof this.selectedCountry == 'undefined') return;
	if (this.layoutManager.current != 'global_scatter') {
		this.layoutManager.layout(
			'global_scatter',
			Infinity,
			undefined,
			0,
			0,
			MAX_YEAR,
			MAX_YEAR
		);
		this.layoutManager.regionColor();
		setTimeout(this.layoutManager.highlight(this.selectedCountry), 500);
	} else {
		this.layoutManager.highlight(this.selectedCountry);
	}

	if (typeof e != 'undefined') {
		e.target.classList.add('active');
		e.target.nextSibling.classList.remove('active');
	} else {
		document
			.querySelectorAll('#js-restrictions-corrected .buttons .button')[0]
			.classList.add('active');
		document
			.querySelectorAll('#js-restrictions-corrected .buttons .button')[1]
			.classList.remove('active');
	}
}
export function handleDropdown(value, text, $choice) {
	if (typeof $choice != 'undefined') {
		this.selectedCountry = value;
		this.dropdown[0].setAttribute('data-iso', this.selectedCountry);
		this.dropdown_icon.classList.add('x');
		this.handleYear();
		this.buttons.classList.add('active');
		document.querySelector('.country-info').classList.add('active');
		setHTML(
			`<p><strong>In ${MAX_YEAR}</strong>, ${this.model.getName(this.selectedCountry, true)} had a <strong>${this.layoutManager._().x_labels(this.model.getGRI(this.selectedCountry)).toLowerCase()}</strong> GRI score and a <strong>${this.layoutManager._().y_labels(this.model.getSHI(this.selectedCountry)).toLowerCase()}</strong> SHI score.</p>
    <p>Use the controls to see the trend from ${this.selectedCountry == '728' ? '2011' : MIN_YEAR} to ${MAX_YEAR} or to search for another country.</p>`,
			'.country-info'
		);

		document.querySelector(
			'#js-restrictions-corrected .buttons .button.trend'
		).textContent =
			`${this.selectedCountry == '728' ? '2011' : MIN_YEAR} - ${MAX_YEAR}`;
		document.querySelector('#js-restrictions-corrected input.search').blur();
	} else {
		this.selectedCountry = undefined;
		this.dropdown.dropdown('restore default text');
		this.dropdown[0].removeAttribute('data-iso');
		this.dropdown_icon.classList.remove('x');
		this.buttons.classList.remove('active');
		this.layoutManager.layout(
			'global_scatter',
			Infinity,
			undefined,
			0,
			0,
			MAX_YEAR,
			MAX_YEAR
		);
		this.layoutManager.regionColor();
		this.layoutManager.setAlpha(0);
		this.layoutManager.setAlphaFirst(1);
		document.querySelector('.country-info').classList.remove('active');
		document.querySelector('.country-info').replaceChildren();
	}
}

export function countryInfo() {
	this.tooltipContainer.classList.remove('active');
	this.dropdown[0].setAttribute('data-iso', this.selectedCountry);
	jQuery('html, body').animate(
		{
			scrollTop: jQuery(this.canvas).offset().top,
		},
		500
	);
	let map_zoom =
		this.width > MID_WIDTH ? 1.95 : this.width > MOBILE_WIDTH ? 1.4 : 1;
	let demo_zoom =
		this.width < MOBILE_WIDTH
			? 2.4
			: this.aspectRatio[0] / this.aspectRatio[1] >= 2
				? 3.2
				: 3.6;
	let offsets = {
		x:
			this.width < MOBILE_WIDTH
				? this.width / 9
				: ((2 / DPR) *
						(this.canvas.width / 2 - this.canvas.width / 2.93)) /
					demo_zoom, //this.width < MID_WIDTH ? 120 : this.width < MAX_WIDTH ? 138 : 172,
		y:
			this.width < MOBILE_WIDTH
				? this.width / 9
				: ((2 / DPR) *
						(this.canvas.height / 2 - this.canvas.height / 2.73)) /
					demo_zoom, //this.width < MID_WIDTH ? 60 : this.width < MAX_WIDTH ? 68 : 83,
	};

	if (typeof this.spare == 'undefined') {
		this.spare = new PIXI.ParticleContainer(this.tiles.features.length, {
			tint: true,
		});
		this.scatter = new PIXI.ParticleContainer(this.tiles.features.length, {
			tint: true,
			scale: true,
		});
		this.spare.addChild(...this.sprites1);
		this.scatter.addChild(...this.sprites2);
		this.spare_container = new PIXI.Container();
		this.scatter_container = new PIXI.Container();
		this.spare_container.addChild(this.spare);
		this.scatter_container.addChild(this.spares_container);
		this.scatter_container.addChild(this.scatter);
		this.app.stage.addChild(this.spare_container);
		this.app.stage.addChild(this.scatter_container);
		this.spare_container.interactiveChildren = false;
		this.scatter_container.interactiveChildren = false;

		this.spareManager = new LayoutManager(
			this.spare.children,
			this.spare_container,
			this.model,
			this.width,
			this.height,
			this._labels1,
			this
		);
		let scatter_dim =
			this.width < 1100
				? this.width / 2 + 30
				: this.width < MID_WIDTH
					? this.spareManager.nodes[0]._width *
						this.spareManager.dim *
						demo_zoom *
						1.15
					: this.spareManager.nodes[0]._width *
						this.spareManager.dim *
						demo_zoom *
						1.218;
		480;
		this.scatterManager = new LayoutManager(
			this.scatter.children,
			this.scatter_container,
			this.model,
			scatter_dim,
			scatter_dim,
			this._labels2,
			this
		);
	}

	let x = d3.scaleLinear(
		[
			0,
			Math.min(
				this.max_grid_size,
				Math.ceil(this.aspectRatio[0] * this.ratio * this.baseScale)
			),
		],
		[-this.canvas.width / DPR / 5, this.canvas.width / DPR / 8]
	);
	let y = d3.scaleLinear(
		[0, Math.ceil(this.aspectRatio[1] * this.ratio * this.baseScale)],
		[this.canvas.height / DPR / 3.5, -this.canvas.height / DPR / 6]
	);
	this.scatter_container.renderable = false;
	this.spare_container.renderable = false;
	this.spareManager.labelSelector.classList.remove('active');
	this.scatterManager.axes.classList.remove('active');
	let mapCentroid = this.layoutManager.getCentroid(
		this.selectedCountry,
		false,
		false,
		'map_Infinity'
	);
	this.spareManager.layout('map');
	let x1 = mapCentroid[0] - x(mapCentroid[0]);
	let y1 =
		mapCentroid[1] +
		y(mapCentroid[1]) +
		(this.width < MOBILE_WIDTH
			? -(this.width / 2 - 20)
			: DPR < 2
				? 120
				: 0);
	this.layoutManager.zoomTo(
		this.layoutManager._zoomLevel || this.layoutManager.zoomLevel,
		map_zoom,
		this.layoutManager._center[0],
		this.layoutManager._center[1],
		x1,
		y1,
		0,
		0,
		0,
		() => {
			this.layoutManager._zoomLevel = map_zoom;
			this.spareManager.resetColor(LIGHT_GRAY);
			this.spareManager.isolateCountry(this.selectedCountry);
			this.spareManager.countryColor(
				this.selectedCountry,
				bivariateColor(
					this.model.getGRI(this.selectedCountry),
					this.model.getSHI(this.selectedCountry)
				)
			);
			this.spareManager.layouts['shi_order'] = null;
			this.spareManager.layouts['demo_order'] = null;
			this.spareManager.create(
				'shi',
				Infinity,
				this.selectedCountry,
				0,
				0,
				2017,
				[this.selectedCountry]
			);
			this.layoutManager.countryColor(
				this.selectedCountry,
				bivariateColor(
					this.model.getGRI(this.selectedCountry),
					this.model.getSHI(this.selectedCountry)
				)
			);
			this.spareManager.zoomTo(
				1,
				map_zoom,
				this.layoutManager._center[0],
				this.layoutManager._center[1],
				x1,
				y1,
				5,
				0,
				0,
				() => {
					this.spare_container.renderable = true;
					this.spareManager._center = [x1, y1];
					this.spareManager.zoomLevel = map_zoom;
					let _centroid = this.spareManager.getCentroid(
						this.selectedCountry,
						this.width < MOBILE_WIDTH ? true : true,
						false,
						'shi_order'
					);
					_centroid[1] -= ~['156', '356'].indexOf(
						this.selectedCountry
					)
						? 5
						: 10;
					this.spareManager.layout(
						'shi',
						Infinity,
						this.selectedCountry,
						0,
						0,
						2017,
						2017,
						[this.selectedCountry]
					);
					this.spareManager.resizeLabels(
						this.spareManager.labelFactor
					);
					//mapCentroid[0]  - 245 - centroid[0] + ( ~["156", "356"].indexOf(this.selectedCountry) ? 175 : 135), mapCentroid[1] + 25 - centroid[1] + ( ~["156", "356"].indexOf(this.selectedCountry) ? 80 : 50)
					this.spareManager.zoomTo(
						this.spareManager.zoomLevel,
						demo_zoom,
						this.spareManager._center[0],
						this.spareManager._center[1],
						_centroid[0] + offsets.x,
						_centroid[1] + offsets.y,
						1,
						0,
						0,
						() => {
							this.spareManager.zoomLevel = demo_zoom;
							this.spareManager.layout(
								'demo',
								Infinity,
								this.selectedCountry,
								0,
								0,
								2017,
								2017,
								[this.selectedCountry]
							);
							this.spareManager.resizeLabels(
								this.spareManager.labelFactor
							);
							this.spareManager.labelSelector.classList.add(
								'active'
							);
							this.layoutManager._center = [x1, y1];
							setTimeout(() => {
								this.scatterManager.resetColor(LIGHT_GRAY);
								this.scatterManager.isolateCountry(
									this.selectedCountry
								);
								if (this.selectedCountry == '728') {
									this.scatterManager.layout(
										'scatter',
										Infinity,
										this.selectedCountry,
										0,
										0,
										2011
									);
								} else {
									this.scatterManager.layout(
										'scatter',
										Infinity,
										this.selectedCountry
									);
								}
								this.scatter_container.renderable = true;
								this.scatterManager.axes.classList.add(
									'active'
								);
							}, 300);
						}
					);
				}
			);
		},
		true
	);
}

export function handleMapEvent(e) {
	if (typeof e.target.iso != 'undefined' && e.target.iso !== '408') {
		this.displayTooltip(e);
		this.layoutManager.resetColor(LIGHT_GRAY);
		this.layoutManager.countryColor(
			e.target.iso,
			bivariateColor(
				this.model.getGRI(e.target.iso),
				this.model.getSHI(e.target.iso)
			)
		);
	}
}

export function handleMapClick(e) {
	this.tooltipContainer.classList.remove('active');
	if (
		typeof e.target.iso != 'undefined' &&
		e.target.iso !== '408' &&
		e.target.iso != this.selectedCountry
	) {
		this.selectedCountry = e.target.iso;
		this.dropdown.dropdown('set selected', this.selectedCountry);
	}
}

export function displayTooltip(e) {
	this.tooltipContainer.classList.add('active');
	this.tooltip.style.cssText = `top:${e.data.originalEvent.y - 10}px;left:${e.data.global.x > this.width - 150 ? e.data.global.x - 100 : e.data.global.x - 10}px;`;
	setHTML(
		`<strong>${this.model.getName(e.target.iso)}</strong>`,
		`.${this.tooltip.className}`
	);
}

export function resize() {
	if (
		typeof this.layoutManager !== 'undefined' &&
		this.layoutManager.zoom_timer._call != null
	)
		return;
	let old_width = parseFloat(this.width);
	this.width = getWidth();
	if (this.mobile_device && this.width == old_width && this._pixi_init)
		return;
	this.height = getHeight();
	this._center = this.center();
	this.aspectRatio =
		this.width < MOBILE_WIDTH || this.width / this.height < 1
			? [1, 1]
			: this.width / this.height > 1.8
				? [2.1, 1]
				: [16, 9];
	// Determine which screen dimension is most constrained
	this.ratio =
		this.width < MOBILE_WIDTH
			? Math.min(
					this.width / this.aspectRatio[0],
					this.height / this.aspectRatio[1],
					640
				)
			: Math.min(
					this.width / this.aspectRatio[0],
					this.height / this.aspectRatio[1]
				);

	this.app.renderer.resize(
		Math.ceil(this.aspectRatio[0] * this.ratio),
		Math.ceil(this.aspectRatio[1] * this.ratio)
	);

	if (this.old_ratio) {
		if (typeof this.layoutManager != 'undefined') {
			this.app.stage.renderable = false;
			let labelFactor = this.last_animation.init_labelFactor;
			let _labelFactor = this.layoutManager.labelFactor;
			let zoomLevel = this.layoutManager.zoomLevel;
			this.last_animation.init_zoom;

			this.bootstrap().then(() => {
				this.layoutManager.layout('map');
				this.layoutManager.labelSelector.style.cssText = ``;
				this.layoutManager.zoomLevel = 1;
				this.last_animation.animate(false, true).then(() => {
					setTimeout(() => {
						this.app.stage.renderable = true;
						setTimeout(() => {
							if (this.last_animation.layout != 'map')
								this.layoutManager.resizeLabels(
									this.layoutManager.labelFactor
								);
							jQuery('#sections section.step').visibility(
								'refresh'
							);
						}, 600);
					}, 350);
				});
			});
		}
	}

	this.old_ratio = this.ratio;
}
export default {
	resize,
	handleDropdown,
	handleMapEvent,
	displayTooltip,
	countryInfo,
	handleMapClick,
};
